// extracted by css-extract-rspack-plugin
export default {"wrapper":"click-outside-module__wrapper___EMH3s"};